module.exports = __webpack_public_path__ + "img/a806177.png";